module.exports = __webpack_public_path__ + "static/aragon-videomock-small-13ac0545f49ab9645653995880a3d1da.mp4";